/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * LogoutIcon - Auto-generated from icon.js
 */
export const LogoutIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.15056 18.848H12.4854C12.805 18.848 13.0607 19.104 13.0607 19.424C13.0607 19.744 12.805 20 12.4854 20H4.57528C4.25568 20 4 19.744 4 19.424V4.576C4 4.256 4.25568 4 4.57528 4H12.4854C12.805 4 13.0607 4.256 13.0607 4.576C13.0607 4.896 12.805 5.152 12.4854 5.152H5.15056V18.848ZM14.9942 8.256L19.8681 11.728C20.0439 11.872 20.0439 12.144 19.8681 12.288L14.9942 15.776C14.7705 15.936 14.4669 15.776 14.4669 15.504V13.264H9.03369C8.84193 13.264 8.69811 13.104 8.69811 12.928V11.104C8.69811 10.912 8.85791 10.768 9.03369 10.768H14.4669V8.528C14.4669 8.256 14.7705 8.096 14.9942 8.256Z"
			fill="current"
		/>
	</svg>
);

export default LogoutIcon;
